import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../shared/layout/layout.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { accountRoutes } from './account.routes';
import { AccountComponent } from './account.component';
import { RechargeConfirmationComponent } from './recharge-confirmation/recharge-confirmation.component';
import { NgxStripeModule } from 'ngx-stripe';
import { SubscriptionPaymentComponent } from './subscription-payment/subscription-payment.component';
import { PaymentSpinnerComponent } from './payment-spinner/payment-spinner.component';
import { PaymentConfirmerComponent } from './payment-confirmer/payment-confirmer.component';
import { SubscriptionCheckoutComponent } from './subscription-checkout/subscription-checkout.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { BillingThankYouComponent } from './billing-thank-you/billing-thank-you.component';

@NgModule({
  imports: [
    CommonModule,
    LayoutModule,
    SharedModule,
    RouterModule.forChild(accountRoutes),
    TranslateModule,
    NgxStripeModule.forRoot(),
    MatButtonToggleModule
  ],
  declarations: [
    AccountComponent,
    RechargeConfirmationComponent,
    BillingThankYouComponent,
    SubscriptionPaymentComponent,
    PaymentSpinnerComponent,
    PaymentConfirmerComponent,
    SubscriptionCheckoutComponent
  ],
  exports: [AccountComponent],
  entryComponents: [AccountComponent, PaymentSpinnerComponent]
})
export class AccountModule {}
